import P2Medium from 'components/typography/P2Medium';
import { MeasuringDeviceRow } from 'components/tables/data/measuring-device/types';

/**
 * Column for the measuring device name.
 */
export default function MeasuringDeviceNameColumn({ data: { measuringDeviceName } }: { data: MeasuringDeviceRow }) {
  return <P2Medium color="gray.8">{measuringDeviceName}</P2Medium>;
}
